import { Button, Sheet, VStack } from '@hover/blueprint';
import React from 'react';

import { Link } from 'src/shared/components';
import { urlWithRedirectTo } from 'src/shared/helpers/routing';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';
import { Route } from 'src/shared/route';

const SignInSheet = () => {
  const t = useTranslate([
    TranslationNamespace.HOMEOWNER_APP,
    TranslationNamespace.COMMON,
  ]);

  return (
    <Sheet.Contents header={t('signInSheet.header')}>
      <VStack align="stretch" py="500" spacing={400}>
        <Button
          as={Link}
          textDecoration="none"
          to={urlWithRedirectTo(
            Route.LOGIN.path,
            Route.HOMEOWNER_APP_HOME.path,
          )}
          variant="tertiary"
          width="100%"
        >
          {t('logIn')}
        </Button>
        <Button
          as={Link}
          textDecoration="none"
          to={urlWithRedirectTo(
            Route.SIGN_UP_HOMEOWNER.path,
            Route.HOMEOWNER_APP_HOME.path,
          )}
          variant="secondary"
          width="100%"
        >
          {t('signUp')}
        </Button>
      </VStack>
    </Sheet.Contents>
  );
};

export { SignInSheet };
